<template lang="pug">
    div(
        v-if="validScorecard"
    )
        v-card(v-if="isLoading" outlined)
            .text-center
                v-progress-circular(
                    :size='100'
                    :width='10'
                    color='var(--volie-blue)'
                    indeterminate
                    style="margin-top: 75px; margin-bottom: 75px;"
                )

        template(v-else-if="isCallCommunicationType")
            VolieTranscription(
                v-if="callTranscription && conference"
                :callTranscription="callTranscription"
                :conference="conference"
                :isLoading="isLoading"
                is-outlined
                hide-speaker-time-chart
            )

            v-card(v-else-if="recordingUrl" outlined)
                v-card-title(style="font-size: 1rem;")
                    | Recording
                    div.audio-wrapper.ml-auto.width-100-percent
                        audio#audio-playback(
                            controls
                            :controlsList=" hideDownloadButtons ? 'nodownload' : ''"
                            :src="recordingUrl"
                    )
                div.py-2.px-4.width-100-percent
                    v-alert(outlined type='info' dense border='left')
                        | There is no call transcription.

            div.py-2.px-4.width-100-percent(v-else)
                v-alert(outlined type='info' dense border='left')
                    | There is no recording or call transcription.


</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { 
        FindConference,
        GetOutgoingCallTranscription,
    } from "@/data";

    // Components
    import VolieTranscription from '@/components/conferences/call_transcriptions/volie_transcription.vue';

    export default Vue.extend({
        data() {
            return {
                callTranscription: null,
                conference: null,
                isLoadingCallTranscription: false,
                isLoadingConference: false,
                recording: null,
            }
        },
        methods: {
            findConference() {
                if (!(this.conferenceVid?.length > 0)) {
                    return;
                }

                this.isLoadingConference = true;

                FindConference(this.conferenceVid).then((response) => {
                    if (response?.Data?.conference?.conference_key?.length > 0) {
                        this.conference = response.Data.conference;
                    }

                    this.isLoadingConference = false;
                });
            },
            getOutgoingInAppCallTranscription() {
                if(!(this.scorecard?.recording_key?.length > 0)) {
                    this.showSnackbar("red", "This conference does not have a recording");
                    return;
                }

                const options = {
                    recording_vid: this.scorecard.recording_key,
                }
   
                this.isLoadingCallTranscription = true;
                GetOutgoingCallTranscription(options).then((response) => {
                    if (response?.Data?.call_transcription?.vid?.length > 0) {
                        this.callTranscription = response.Data.call_transcription;
                    }

                    this.isLoadingCallTranscription = false;
                });
            },
            init() {
                if (this.isCallCommunicationType) {
                    this.findConference();
                    this.getOutgoingInAppCallTranscription();
                }
                return;
            },
        },
        computed: {
            conferenceVid() {
                return this.scorecard?.conference_vid;
            },
            isCallCommunicationType() {
                if (!this.validScorecard) {
                    return false;
                }

                if (["call", "incoming_call", "outgoing_call"].includes(this.scorecard.communication_type)) {
                    return true;
                }

                return false;
            },
            isLoading() {
                if (this.isLoadingCallTranscription || this.isLoadingConference) {
                    return true;
                }

                return false;
            },
            recordingUrl() {
                return this.scorecard?.recording_url;
            },
            validScorecard() {
                return this.scorecard?.scorecard_id > 0;
            },
        },
        components: {
            VolieTranscription,
        },
        props: {
            hideDownloadButtons: {
                type: Boolean,
                required: false,
            },
            scorecard: Object,
        },
        created() {
            this.init();
        },
    });
</script>

<style lang="scss" scoped>
</style>
